import {useState, useEffect} from 'react'
import close from 'shared/ui/DefaultModal/asset/close.svg'
import Style from './style'

import fomular from 'shared/assets/ranking/formula.png'
import ranking from 'shared/assets/ranking/ranking.png'
import BgImage from 'shared/assets/background/ranking-background.png'

import RankingInfoLoading from './RankingInfoLoading'

const RankingInfo = ({closeEvent}) => {
	const [isRankingLoaded, setIsRankingLoaded] = useState(false)
	const [isFormulaLoaded, setIsFormulaLoaded] = useState(false)
	const [isBgLoaded, setIsBgLoaded] = useState(false)
	const [isScrolled, setIsScrolled] = useState(false)

	const isAllLoaded = isRankingLoaded && isFormulaLoaded && isBgLoaded

	useEffect(() => {
		document.body.style.overflow = 'hidden'
		return () => {
			document.body.style.overflow = 'unset'
		}
	}, [])

	const handleScroll = (e) => {
		setIsScrolled(e.target.scrollTop > 0)
	}

	return (
		<Style.Wrapper>
			<Style.Container onScroll={handleScroll} $bgImage={BgImage}>
				<Style.Header $isScrolled={isScrolled}>
					<h2>순위 정보</h2>
					<img src={close} alt='close' onClick={closeEvent} />
				</Style.Header>
				<div style={{display: isAllLoaded ? 'flex' : 'none'}}>
					<img
						src={ranking}
						alt='ranking'
						onLoad={() => setIsRankingLoaded(true)}
						style={{
							width: '100%',
							height: 'auto',
							objectFit: 'cover',
							paddingBottom: '24px',
						}}
					/>
				</div>
				<div style={{display: 'none'}}>
					<img src={BgImage} alt='bg' onLoad={() => setIsBgLoaded(true)} />
				</div>
				<Style.Content>
					{!isAllLoaded && <RankingInfoLoading />}

					<div style={{display: isAllLoaded ? 'flex' : 'none'}}>
						<img
							src={fomular}
							alt='fomular'
							onLoad={() => setIsFormulaLoaded(true)}
							style={{
								width: '100%',
								height: 'auto',
								objectFit: 'cover',
							}}
						/>
					</div>

					<div style={{display: isAllLoaded ? 'block' : 'none'}}>
						<div>
							<Style.WeightTable>
								<Style.WeightHeader>
									<h3>이벤트 유형별 가중치</h3>
								</Style.WeightHeader>
								<Style.WeightList>
									<Style.WeightRow>
										<div>
											<h4>OFFICIAL</h4>
										</div>
										<Style.Star>
											<svg
												width='16'
												height='16'
												viewBox='0 0 16 16'
												fill='none'
											>
												<path
													d='M8 1L10.163 5.278L15 6L11.5 9.324L12.326 14L8 11.778L3.674 14L4.5 9.324L1 6L5.837 5.278L8 1Z'
													fill='#F4B04C'
												/>
											</svg>
											<p>2.5</p>
										</Style.Star>
									</Style.WeightRow>
									<Style.WeightRow>
										<div>
											<h4>TRYOUT</h4>
										</div>
										<Style.Star>
											<svg
												width='16'
												height='16'
												viewBox='0 0 16 16'
												fill='none'
											>
												<path
													d='M8 1L10.163 5.278L15 6L11.5 9.324L12.326 14L8 11.778L3.674 14L4.5 9.324L1 6L5.837 5.278L8 1Z'
													fill='#F4B04C'
												/>
											</svg>
											<p>1.5</p>
										</Style.Star>
									</Style.WeightRow>
									<Style.WeightRow>
										<div>
											<h4>PRELIMINARY</h4>
										</div>
										<Style.Star>
											<svg
												width='16'
												height='16'
												viewBox='0 0 16 16'
												fill='none'
											>
												<path
													d='M8 1L10.163 5.278L15 6L11.5 9.324L12.326 14L8 11.778L3.674 14L4.5 9.324L1 6L5.837 5.278L8 1Z'
													fill='#F4B04C'
												/>
											</svg>
											<p>1.3</p>
										</Style.Star>
									</Style.WeightRow>
									<Style.WeightRow>
										<div>
											<h4>STORE/FREEROLL</h4>
										</div>
										<Style.Star>
											<svg
												width='16'
												height='16'
												viewBox='0 0 16 16'
												fill='none'
											>
												<path
													d='M8 1L10.163 5.278L15 6L11.5 9.324L12.326 14L8 11.778L3.674 14L4.5 9.324L1 6L5.837 5.278L8 1Z'
													fill='#F4B04C'
												/>
											</svg>
											<p>1.0</p>
										</Style.Star>
									</Style.WeightRow>
								</Style.WeightList>
							</Style.WeightTable>
						</div>

						<div
							style={{
								marginTop: '24px',
							}}
						>
							<Style.ConditionCard>
								<Style.ConditionHeader>
									<h3>랭킹 포인트 획득 조건</h3>
								</Style.ConditionHeader>
								<Style.ConditionList>
									<Style.ConditionRow>
										<svg
											width='14'
											height='14'
											viewBox='0 0 14 14'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'
										>
											<rect width='14' height='14' rx='3' fill='#3DDF2B' />
											<path
												d='M2.5 7L5.5 10.5L11 4'
												stroke='white'
												stroke-width='1.5'
												stroke-linecap='round'
												stroke-linejoin='round'
											/>
										</svg>
										<p>참여자 중 상위 12.5% 이내에 랭크된 경우.</p>
									</Style.ConditionRow>
									<Style.ConditionRow>
										<svg
											width='14'
											height='14'
											viewBox='0 0 14 14'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'
										>
											<rect width='14' height='14' rx='3' fill='#3DDF2B' />
											<path
												d='M2.5 7L5.5 10.5L11 4'
												stroke='white'
												stroke-width='1.5'
												stroke-linecap='round'
												stroke-linejoin='round'
											/>
										</svg>
										<p>
											<strong>종료 시간(Leaving Time)</strong>이 기록된 경우
											(대회를 정상적으로 마침).
										</p>
									</Style.ConditionRow>
									<Style.ConditionRow>
										<svg
											width='14'
											height='14'
											viewBox='0 0 14 14'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'
										>
											<rect width='14' height='14' rx='3' fill='#3DDF2B' />
											<path
												d='M2.5 7L5.5 10.5L11 4'
												stroke='white'
												stroke-width='1.5'
												stroke-linecap='round'
												stroke-linejoin='round'
											/>
										</svg>
										<p>해당 이벤트의 참여자가 최소 2명 이상일 경우.</p>
									</Style.ConditionRow>
								</Style.ConditionList>
							</Style.ConditionCard>
						</div>
					</div>
				</Style.Content>
			</Style.Container>
		</Style.Wrapper>
	)
}

export default RankingInfo
